module.exports = __webpack_public_path__ + "static/media/navidad16.9e56e0ae.jpg";